import * as React from "react";
import ReactDOM from "react-dom";
import WsRoot from "./WebSockets/WsRoot";

export const wsName = "umWebSockets";
const wsRootId = "webSocketsRootElement";

let wsRoot = document.createElement("div");
wsRoot.id = wsRootId;

let body = document.getElementsByTagName("body");
body[0].appendChild(wsRoot);

ReactDOM.render(<WsRoot ref={x => {
  window[wsName] = x;
}} />, document.getElementById(wsRootId));